import apiClient from './client';
import { DataSource } from '../types';

export const dataSourcesApi = {
  /**
   * List all data sources for a client
   */
  listDataSources: async (clientId: string): Promise<DataSource[]> => {
    const response = await apiClient.get<DataSource[]>(
      `/clients/${clientId}/data-sources`
    );
    return response.data;
  },

  /**
   * Upload a file (bank statement, etc.)
   */
  uploadFile: async (
    clientId: string,
    formData: FormData,
    onUploadProgress?: (progressEvent: any) => void
  ): Promise<DataSource> => {
    const response = await apiClient.post<DataSource>(
      `/clients/${clientId}/data-sources/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
      }
    );
    return response.data;
  },

  /**
   * Get download URL for a file
   */
  getDownloadUrl: async (clientId: string, sourceId: string): Promise<string> => {
    const response = await apiClient.get<{ url: string }>(
      `/clients/${clientId}/data-sources/${sourceId}/download`
    );
    return response.data.url;
  },

  /**
   * Get preview URL for a file (uses view endpoint which prefers viewer_path for converted PDFs)
   */
  getPreviewUrl: async (clientId: string, sourceId: string): Promise<string> => {
    const response = await apiClient.get<{ url: string }>(
      `/clients/${clientId}/data-sources/${sourceId}/view`
    );
    return response.data.url;
  },

  /**
   * Trigger file parsing (returns job_id for background processing)
   */
  parseFile: async (clientId: string, sourceId: string, parseType: string): Promise<{ job_id: string }> => {
    const response = await apiClient.post<{ job_id: string }>(`/clients/${clientId}/data-sources/${sourceId}/parse`, {
      parse_type: parseType,
    });
    return response.data;
  },

  /**
   * Delete a data source
   */
  deleteDataSource: async (clientId: string, sourceId: string): Promise<void> => {
    await apiClient.delete(`/clients/${clientId}/data-sources/${sourceId}`);
  },
};
